import { principalServiceRequest } from './base-request';
import { ConfigPowerBI } from './powerbit-endpoints.types';
import { useQuery } from '@tanstack/react-query';

type PowerBiEmbedTokenRequestDto = {
  principalManufacturerName: string;
};

export const getPowerBiConfiguration = async () => {
  return await principalServiceRequest<ConfigPowerBI>(
    'get',
    'reports/configuration',
  );
};

export const getPowerBiEmbedToken = async (
  data: PowerBiEmbedTokenRequestDto,
): Promise<string> => {
  return (
    await principalServiceRequest<string>('post', 'reports/embed-token', data)
  ).data;
};

export const usePowerBiEmbedToken = (principalManufacturerName: string) => {
  return useQuery({
    queryKey: ['powerBiEmbedToken', principalManufacturerName],
    queryFn: () =>
      principalServiceRequest<string>('post', 'reports/embed-token', {
        principalManufacturerName,
      }),
    select: ({ data }) => data,
    enabled: !!principalManufacturerName,
  });
};
